module.exports = [{
      plugin: require('../../../node_modules/.pnpm/gatsby-plugin-google-gtag@5.16.0_gatsby@5.16.1_babel-eslint@10.1.0_eslint@7.32.0__react-dom@1_qb4huymzlgnb4ocznhwbae6wqa/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-FN9XE9YPJ7"],"gtagConfig":{}},
    },{
      plugin: require('../../../node_modules/.pnpm/gatsby@5.16.1_babel-eslint@10.1.0_eslint@7.32.0__react-dom@19.2.4_react@19.2.4__react@19.2.4__mfvm6iqgcninmuv3pmtgcyrl4q/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
